import {
  DateTimeRangeFilter,
  FileList,
  Filters,
  ListHeader,
  ListPageLayout,
  StaticFiltersLayout,
} from 'framework/list';
import ArtifactsAuditManual from './manual';
import useAuditService from 'domain/audit/shared/auditService';

const ArtifactsAuditList = () => {
  const { getArtifactsConfigurationReport } = useAuditService();

  const filters = (
    <Filters>
      <StaticFiltersLayout actionButtonName="Download">
        <DateTimeRangeFilter label="Date Of Access" source="dateOfAccess" />
      </StaticFiltersLayout>
    </Filters>
  );

  return (
    <FileList getDataMethod={getArtifactsConfigurationReport}>
      <ListPageLayout
        showTotal={false}
        header={<ListHeader label="Artifacts Access Audit" icon="fa-file" />}
        filter={filters}
      >
        <ArtifactsAuditManual />
      </ListPageLayout>
    </FileList>
  );
};

export default ArtifactsAuditList;
